<template>
  <layout-default-appbar
    :back-to="true">
    Carga Total
  </layout-default-appbar>
</template>

<script>

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'CargaTotalAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
    };
  },
};
</script>
